"use client";
import { stripBrandingKeywords as n } from "./utils/strip-branding-keywords.js";
import { standardizeSuffixes as o } from "./utils/standardize-suffixes.js";
const f = (r, e) => {
  let t = r.title;
  if (!t) return "";
  const i = e?.organizationDisplayName;
  return t = o(t), i && (t = n(t, i)), t;
};
export {
  f as getTitle
};
